export const TR_DELETE_MESSAGE_KEY = 'TR_DELETE_MESSAGE';
export const TR_CREATE_MESSAGE_KEY = 'TR_CREATE_MESSAGE';
export const TR_UPDATE_MESSAGE_KEY = 'TR_UPDATE_MESSAGE';
export const TR_DATA_SAVED_KEY = 'TR_DATA_SAVED';